import { render, staticRenderFns } from "./principleCorporates.vue?vue&type=template&id=6809f15e&"
import script from "./principleCorporates.vue?vue&type=script&lang=js&"
export * from "./principleCorporates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports